import {
  FinancialCalendar,
  GlobalFootprint,
  InvestmentCase,
  InvestorEngagement,
  InvestorInformation,
  InvestorRelationsPageHeader,
  InvestorResources,
  LatestDisclosures,
  ProjectHighlights,
  QuarterEarnings,
} from "@modules/investor-relations/components";
import { toolLocales } from "@modules/investor-relations/utils";
import { getCurrentLocaleCode } from "@mongez/localization";

export function InvestorRelationsLandingPage() {
  const locale = getCurrentLocaleCode();
  const { standard } = toolLocales(locale);

  return (
    <section className="relative min-h-dvh bg-[#f7f9fc]">
      <InvestorRelationsPageHeader />

      {/* Scrolling ticker */}
      <div className="container">
        <euroland-tool
          data-tool-name="Ticker"
          data-tool-version="scrolling"
          data-tool-language={standard}
        />
      </div>

      <GlobalFootprint />
      <InvestmentCase />
      <QuarterEarnings />
      <InvestorResources />
      <ProjectHighlights />
      <LatestDisclosures />
      <FinancialCalendar />
      <InvestorInformation standard={standard} />
      <InvestorEngagement />
    </section>
  );
}
